import PaletteCard, {
  handlePaletteGroupKeyDown,
} from "components/shared/PaletteCard";
import { DEFAULT_THEME_PALETTE, THEME_PALETTES } from "constants/themes";
import { useThemePalette } from "hooks/useThemePalette";
import { useTranslation } from "react-i18next";

// Resolved inside each card's `data-theme-preview`, so every card shows its own palette.
const PREVIEW_SWATCHES = [
  "rgb(var(--color-chrome))",
  "rgb(var(--color-brand-strong))",
  "rgb(var(--color-brand))",
  "rgb(var(--color-brand-highlight))",
  "rgb(var(--color-brand-tint))",
];

const ThemePalettePicker = () => {
  const { t } = useTranslation();
  const { themePalette, changeThemePalette } = useThemePalette();

  return (
    <div
      role="radiogroup"
      aria-label={t("settings.palette")}
      onKeyDown={handlePaletteGroupKeyDown}
      className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-2 2xl:grid-cols-3"
    >
      {THEME_PALETTES.map((palette) => (
        <PaletteCard
          key={palette.id}
          previewThemeId={palette.id}
          name={t(palette.labelKey)}
          gradientFrom="rgb(var(--color-brand))"
          gradientTo="rgb(var(--color-brand-highlight))"
          swatches={PREVIEW_SWATCHES}
          isSelected={themePalette === palette.id}
          tabIndex={themePalette === palette.id ? 0 : -1}
          onClick={() => changeThemePalette(palette.id)}
          badge={
            palette.id === DEFAULT_THEME_PALETTE && (
              <span className="rounded-full bg-brand-tint px-1.5 text-[11px] text-brand">
                {t("settings.palettes.default")}
              </span>
            )
          }
        />
      ))}
    </div>
  );
};

export default ThemePalettePicker;
